import type { FC } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconArrowRight } from '@sorare/core/src/atoms/icons/system/iconArrowRight.ts';
import { iconChevronDoubleTop } from '@sorare/core/src/atoms/icons/system/iconChevronDoubleTop.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

const TextShine = styled.span`
  text-shadow: 0px 1px 7px var(--c-yellow-400);
`;
const FilterShine = styled.span`
  filter: drop-shadow(0px 1px 7px var(--c-yellow-400));
`;

type Props = {
  value: number;
  valueIncreased: number;
  Label: FC<{ value: number }>;
  size?: 'small' | 'medium' | 'large';
};

export const ImprovementChip = ({
  value,
  valueIncreased,
  Label,
  size = 'medium',
}: Props) => {
  return (
    <Chip color="yellow" size={size}>
      <Horizontal as="span" gap={0.5}>
        <span>
          <Label value={value} />
        </span>
        {valueIncreased > value && (
          <>
            <FontAwesomeIcon
              icon={iconArrowRight}
              color="var(--c-yellow-400)"
            />
            <TextShine>
              <Label value={valueIncreased} />
            </TextShine>
            <FilterShine>
              <FontAwesomeIcon icon={iconChevronDoubleTop} />
            </FilterShine>
          </>
        )}
      </Horizontal>
    </Chip>
  );
};
